<template>
  <div class="b1 assetbox assetadd" ref="parentbox" style="min-width: 1300px">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">资产入库</span>
    </div>
    <div class="divider_box">
      <el-divider content-position="left"
        ><span class="dividerTitle">基本信息</span></el-divider
      >
    </div>
    <!-- label="staffName" -->

    <div style="padding: 0px 20px 60px">
      <el-form
        class="elFormClass"
        :model="formParams"
        ref="ruleForm"
        label-width="auto"
        size="small"
      >
        <div class="flex_between_wrap" style="width: 1276px">
          <el-form-item
            :prop="start.model"
            :rules="start.rules ? formRules.requiredChange : formRules.not"
            style="width: 356px"
            v-for="(start, sindex) in formItemFirst"
            :key="sindex"
            :label="start.label"
          >
            <div class="flex_start">
              <x-Treeselect
              :key="treeKey"
                style="flex: 1"
                :placeholder="'请选择' + start.label"
                @input="closeassetClassify"
                @select="assetClassifyselect"
                v-if="start.model == 'assetClassify'"
                v-model="formParams[start.model]"
                :clearable="true"
                :multiple="false"
                :load-options="loadOptions"
                :options="classifyArr"
                value="id"
                label="cName"
                id="id"
              ></x-Treeselect>
              <!-- 使用组织 -->

              <x-Treeselect
                style="flex: 1"
                :defaultExpandLevel="Infinity"
                :placeholder="'请选择' + start.label"
                @select="useDeptselect"
                @input="closeuseDeptselect"
                v-else-if="start.model == 'useDeptId'"
                v-model="formParams[start.model]"
                :clearable="true"
                :multiple="false"
                :options="deptArr"
                value="id"
                label="deptName"
                id="id"
              ></x-Treeselect>
              <!-- 所属组织 -->
              <x-Treeselect
                style="flex: 1"
                :defaultExpandLevel="Infinity"
                :placeholder="'请选择' + start.label"
                @input="closedeptselect"
                @select="deptselect"
                v-else-if="start.model == 'deptId'"
                v-model="formParams[start.model]"
                :clearable="true"
                :multiple="false"
                :options="deptArr"
                value="id"
                label="deptName"
                id="id"
              ></x-Treeselect>
              <!-- 管理员 -->
              <!-- <x-select
                :placeholder="'请选择' + start.label"
                ref="assetAdmin"
                style="flex:1;"
                v-else-if="start.model == 'assetAdmin'"
                @change="assetAdminChange"
                label="staffName"
                model="id"
                v-model="formParams[start.model]"
                url="/pc/admin/page"
                :params="{
                  type: 'admin',
                }"
              ></x-select> -->

              <el-input
                @focus="assetAdminFocus"
                v-else-if="start.model == 'assetAdminName'"
                :placeholder="'请选择' + start.label"
                v-model="formParams[start.model]"
              ></el-input>
              <!-- 区域 -->
              <x-select
                :placeholder="'请选择' + start.label"
                ref="area"
                style="flex: 1"
                v-else-if="start.model == 'areaId'"
                @change="areaChange"
                label="aName"
                model="id"
                v-model="formParams[start.model]"
                url="/pc/area/page"
                :params="{ size: 9999 }"
              ></x-select>
              <!-- 资产来源 -->

              <x-select
                ref="source"
                :placeholder="'请选择' + start.label"
                style="flex: 1"
                v-else-if="start.model == 'sourceId'"
                @change="sourceChange"
                label="defValue"
                model="id"
                :isopen="true"
                v-model="formParams[start.model]"
                url="/pc/dictionary/page"
                :params="{ defType: 'source', size: 9999 }"
              ></x-select>

              <el-button
                @click="start_add(start.model)"
                v-if="start.label !== '资产来源'"
                class="iconfont icon-hao addBtn flex_center_wrap"
              ></el-button>
            </div>
          </el-form-item>
        </div>
        <div class="divider_box">
          <el-divider content-position="left"
            ><span class="dividerTitle">资产信息</span></el-divider
          >
        </div>
        <div class="flex_between_wrap" style="width: 1276px">
          <el-form-item
            prop="enteringType"
            :rules="formRules.requiredChange"
            style="width: 356px"
            label="录入方式"
          >
            <div class="flex_start">
              <div class="entering-box">
                <div
                  :class="formParams.enteringType ? 'enteringActive' : ''"
                  @click="enteringTypeChange(true)"
                >
                  <span></span><span>逐个录入</span>
                </div>
                <div
                  @click="enteringTypeChange(false)"
                  :class="!formParams.enteringType ? 'enteringActive' : ''"
                >
                  <span></span><span>批量录入</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <template v-if="formParams.enteringType">
          <div
            class="flex_between_wrap"
            v-for="(item, index) in formParams.items"
            :key="index"
            style="width: 1276px"
          >
            <el-form-item
              :prop="`items[${index}].` + last.model"
              :rules="last.rules ? formRules.requiredChange : formRules.not"
              style="width: 356px"
              v-for="(last, lindex) in formItemlast"
              :key="lindex"
              :label="last.label"
            >
              <div class="flex_start">
                <!-- 使用人 -->

                <el-input
                  style="flex:1"
                  :placeholder="
                    formParams.useDeptId
                      ? '请选择' + last.label
                      : '请先选择使用组织'
                  "
                  v-if="last.model == 'usePersonName'"
                  v-model="formParams.items[index][last.model]"
                  @focus="usePersonFocus(index, formParams.useDeptId)"
                ></el-input>
                <!-- <x-select
                ref="usePerson"
                @change="
                  usePersonChange(formParams.items[index][last.model], index)
                "
                :placeholder="
                  formParams.useDeptId
                    ? '请选择' + last.label
                    : '请先选择使用组织'
                "
                style="flex:1;"
                v-if="last.model == 'usePerson'"
                label="staffName"
                model="id"
                :queryNow="false"
                :isopen="true"
                v-model="formParams.items[index][last.model]"
                url="/pc/admin/page"
                :params="userparams"
              >
              </x-select> -->

                <el-input
                  style="flex:1"
                  v-else
                  clearable
                  :readonly="last.model == 'assetEpc' ? true : false"
                  @focus="last.model == 'assetEpc' && setEpcmodel(index)"
                  v-model="formParams.items[index][last.model]"
                  size="small"
                ></el-input>
                <el-button
                  @click="start_add('assetAdminName')"
                  v-if="last.model == 'usePersonName'"
                  class="iconfont icon-hao addBtn flex_center_wrap"
                ></el-button>
                <el-button
                  @click="epcBind(formParams.items[index]['assetEpc'], index)"
                  v-if="last.model == 'usePersonName'"
                  type="submit"
                  >绑定EPC</el-button
                >
                <el-button
                  @click="add_items(index)"
                  style="width: 64px"
                  v-if="
                    last.model == 'usePersonName' &&
                      formParams.items.length !== 1
                  "
                  type="submit"
                  >删除</el-button
                >
              </div>
            </el-form-item>
          </div>
          <div>
            <el-button @click="add_items(-1)" type="submit">新增</el-button>
          </div>
        </template>
        <template v-if="!formParams.enteringType">
          <div class="flex_between_wrap" style="width: 1276px">
            <el-form-item
              v-for="(item, index) in formItemEntering"
              :key="index"
              :prop="item.model"
              :rules="item.rules ? formRules.requiredChange : formRules.not"
              style="width: 356px"
              :label="item.label"
            >
              <div
                v-if="item.model == 'countCodes'"
                data-other="other"
                class="flex_start"
              >
                <el-input
                  disabled
                  v-model="formParams.items[0].assetCode"
                ></el-input>
                <span
                  v-if="formParams.items.length > 1"
                  style="color: #1e1e1e; font-size: 14px; margin: 0px 22px"
                  >至</span
                >
                <el-input
                  v-if="formParams.items.length > 1"
                  disabled
                  v-model="
                    formParams.items[formParams.items.length - 1].assetCode
                  "
                ></el-input>
              </div>

              <el-input
                v-else-if="item.model == 'assetName'"
                v-model="formParams[item.model]"
                clearable
                @blur="assetNameChange(formParams[item.model])"
                :disabled="item.readonly"
                :placeholder="'请输入' + item.label"
              ></el-input>
              <el-input-number
                style="width: 100%"
                :controls="false"
                :min="1"
                v-else-if="item.model == 'countNum' && item.label == '资产数量'"
                v-model="formParams[item.model]"
                :placeholder="'请输入' + item.label"
                @blur="getCodes"
              ></el-input-number>
              <el-input
                v-else-if="item.model == 'startCode'"
                v-model="formParams[item.model]"
                clearable
                @blur="getCodes"
                :disabled="item.readonly"
                :placeholder="'请输入' + item.label"
              ></el-input>

              <el-input
                v-else
                v-model="formParams[item.model]"
                clearable
                :disabled="item.readonly"
                :placeholder="'请输入' + item.label"
              ></el-input>
            </el-form-item>
            <!-- 占位 -->
            <el-form-item label="" style="width: 356px; display: hidden">
            </el-form-item>
          </div>
        </template>

        <div class="divider_box">
          <el-divider content-position="left"
            ><span class="dividerTitle">自定义信息</span></el-divider
          >
        </div>

        <el-form-item
          :rules="formRules.requiredChange"
          label="选择资产模板"
          prop="tempId"
          style="width: 356px"
        >
          <x-select
            ref="temp"
            @change="tempChange"
            placeholder="请选择资产模板"
            style="flex: 1"
            label="tName"
            model="id"
            v-model="formParams['tempId']"
            url="/pc/template/temp/page"
            :params="{ size: 9999 }"
          >
          </x-select>
        </el-form-item>
        <div
          class="flex_between_wrap"
          style="width: 1276px"
          v-if="formParams.tempCustom && formParams.tempCustom.length"
        >
          <el-form-item
            :prop="`tempCustom[${tempindex}].value`"
            style="width: 356px"
            v-for="(tempitem, tempindex) in formParams.tempCustom"
            :key="tempindex"
            :rules="
              tempitem.whetherRequired
                ? formRules.requiredChange
                : formRules.not
            "
            :label="tempitem.formTitle"
          >
            <el-input
              clearable
              :placeholder="'请输入' + tempitem.formTitle"
              v-if="tempitem.formLabel == 'text'"
              size="small"
              v-model="formParams.tempCustom[tempindex]['value']"
            ></el-input>
            <el-select
              clearable
              style="width: 100%"
              v-else-if="tempitem.formLabel == 'select'"
              v-model="formParams.tempCustom[tempindex]['value']"
              :placeholder="'请选择' + tempitem.formTitle"
            >
              <el-option
                v-for="(se, sindex) in tempitem.selectDatas"
                :key="sindex"
                :label="se"
                :value="se"
              >
              </el-option>
            </el-select>
            <el-date-picker
              style="width: 100%"
              v-else-if="tempitem.formLabel == 'time'"
              v-model="formParams.tempCustom[tempindex]['value']"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="'请选择' + tempitem.formTitle"
            >
            </el-date-picker>
          </el-form-item>
          <div style="width: 356px"></div>
        </div>
        <div class="divider_box">
          <el-divider content-position="left"
            ><span class="dividerTitle">其他信息</span></el-divider
          >
        </div>

        <div class="flex_between_wrap" style="width: 1276px">
          <el-form-item
            :prop="order.model"
            :rules="order.rules ? formRules.requiredChange : formRules.not"
            style="width: 356px"
            v-for="(order, oindex) in formItemOrder"
            :key="oindex"
            :label="order.label"
          >
            <!--2021/09/07 让用户自己计算多少个月 这个先保留着，后面估计要用 -->
            <!-- <el-date-picker
              style="width:100%"
              v-if="order.model == 'liveTime'"
              v-model="formParams[order.model]"
              type="month"
              value-format="yyyy-MM"
              :placeholder="'请选择' + order.label"
            >
            </el-date-picker> -->

            <el-input
              clearable
              size="small"
              v-int
              style="width: 100%"
              v-if="order.model == 'liveTime'"
              v-model="formParams[order.model]"
              :pl="'请输入使用期限,只能输入整数'"
            ></el-input>
            <el-input-number
              style="width: 100%"
              :controls="false"
              :precision="2"
              :min="0"
              v-else-if="order.model == 'price'"
              v-model="formParams[order.model]"
              :placeholder="'请输入' + order.label"
            ></el-input-number>
            <el-date-picker
              style="width: 100%"
              v-else-if="order.model == 'inTime'"
              v-model="formParams[order.model]"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="'请选择' + order.label"
            >
            </el-date-picker>
            <x-select
              filterable
              allow-create
              default-first-option
              ref="unit"
              model="defValue"
              label="defValue"
              placeholder="'支持手动创建Enter提交'"
              style="flex: 1"
              v-else-if="order.model == 'unit'"
              v-model="formParams[order.model]"
              url="/pc/dictionary/page"
              :params="{ defType: 'unit', size: 9999 }"
            >
            </x-select>
            <el-upload
              v-else-if="order.model == 'cover'"
              class="avatar-uploader"
              :action="uploadAction"
              :show-file-list="false"
              :multiple="false"
              :on-success="successfield"
              auto-upload
              :on-error="errorfield"
              :before-upload="beforeUpload"
              :data="{ fileType: `asset` }"
              :headers="serveHeader"
            >
              <img
                v-if="formParams.cover"
                :src="formParams.cover"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span
                v-if="!formParams.cover"
                class="el-upload__text"
                style="color: #e0e0e0; padding: 0px 10px; font-size: 12px"
              >
                可上传jpg、jpeg、png文件，且单张不超过2M
              </span>
            </el-upload>
            <el-input
              autosize
              clearable
              v-model="formParams[order.model]"
              v-else
              size="small"
              :placeholder="'请输入' + order.label"
              :type="order.model == 'remark' ? 'textarea' : 'text'"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="box_bottom">
      <div class="flex_end">
        <!-- <el-button type="submit" @click="resetForm">重置</el-button> -->
        <el-button type="submit" @click="submit">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      width_bottom: null,
      /* 图片上传 start */
      uploadAction: this.$global.baseURL + "/public/uploadFile",

      serveHeader: {
        Authorization: sessionStorage.getItem("ZCTOKEN"),
        deviceCode: localStorage.getItem("deviceCode"),
      },
      /* 图片上传 end */
      userparams: {
        deptId: "",
        type: "all",
      },
      deptArr: [],
      formItemEntering: [
        {
          label: "起始资产编码",
          model: "startCode",
          rules: true,
          readonly: false,
        },
        {
          label: "资产名称",
          model: "assetName",
          rules: true,
          readonly: false,
        },
        {
          label: "资产数量",
          model: "countNum",
          rules: true,
          readonly: false,
        },
        {
          label: "入库合计",
          model: "countNum",
          rules: false,
          readonly: true,
        },
        {
          label: "资产编码",
          model: "countCodes",
          readonly: true,
        },
      ],

      formItemOrder: [
        {
          label: "入库时间",
          model: "inTime",
          rules: true,
        },
        {
          label: "价值(RMB)",
          model: "price",
          rules: true,
        },
        {
          label: "存放地点",
          model: "depositArea",
        },
        {
          label: "规格型号",
          model: "spec",
        },
        {
          label: "计量单位",
          model: "unit",
        },

        {
          label: "使用期限(月)",
          model: "liveTime",
        },

        {
          label: "供应商",
          model: "supplier",
        },
        {
          label: "供应商电话",
          model: "supplierPhone",
        },
        {
          label: "备注",
          model: "remark",
        },
        {
          label: "照片",
          model: "cover",
        },
      ],
      classifyArr: [],
      treeKey:0,
      formItemlast: [
        {
          label: "资产编码",
          model: "assetCode",
          rules: true,
        },
        {
          label: "资产名称",
          model: "assetName",
          rules: true,
        },
        {
          label: "使用人",
          model: "usePersonName",
        },
      ],
      formItemFirst: [
        {
          label: "资产分类",
          model: "assetClassify",
          rules: true,
        },
        {
          label: "所属组织",
          model: "deptId",
          rules: true,
        },
        {
          label: "管理员",
          model: "assetAdminName",
        },
        {
          label: "使用组织",
          model: "useDeptId",
        },

        {
          label: "所在区域",
          model: "areaId",
          rules: true,
        },
        {
          label: "资产来源",
          model: "sourceId",
          rules: true,
        },
      ],
      currentCode: "",
      formParams: { items: [{}], useDeptId: null, enteringType: true },
      newForm: { items: [{}], useDeptId: null, enteringType: true },
      userIndex: 0,
    };
  },
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    loadOptions({ action, parentNode, callback }) {
      console.log(action, parentNode, callback);
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: parentNode.id },
        },
        (data) => {
          let newData = data.data || [];
          let result = newData.map((item) => {
            item.label = item.cName;
            item.children = null;
            return item;
          });
          parentNode.children = result;
          callback();
        }
      );
    },
    epcBindCallBack(epc = "", index) {
      this.$set(this.formParams.items[index], "assetEpc", epc);
    },
    epcBind(epc, index) {
      let epcList = [];
      this.formParams.items.forEach((item) => {
        if (item.assetEpc) {
          epcList.push(item.assetEpc);
        }
      });
      console.log(epcList);
      this.$createDialog(this, {
        dialogConfig: { title: "EPC绑定", width: "440px" },
        namespace: "asset_add_bind",
        whetherDestruction: true,
        assemblyConfig: {
          epc,
          epcList,
          index,
          callBack: this.epcBindCallBack,
        },
      });
    },
    assetNameChange(data) {
      console.log(data);
      if (this.formParams.items.length) {
        this.formParams.items.forEach((item, index) => {
          this.$set(this.formParams.items[index], "assetName", data);
        });
        console.log(this.formParams.items);
      }
    },
    getCodesList(data, callBack) {
      console.log("执行了吗");
      this.$requestAxios(
        {
          url: "/pc/asset/get_codes",
          data: data,
        },
        (res) => {
          if (callBack) {
            callBack(res.data);
          }
          console.log(res);
        }
      );
    },
    getCodes() {
      if (this.formParams.startCode && this.formParams.countNum) {
        this.$requestAxios(
          {
            url: "/pc/asset/get_codes",
            data: {
              code: this.formParams.startCode,
              count: this.formParams.countNum,
            },
          },
          (res) => {
            this.$set(this.formParams, `items`, []);
            // res.data.splice(0,1)
            console.log(res.data);
            res.data.forEach((item) => {
              this.formParams.items.push({
                assetCode: item,
                assetName: this.formParams.assetName,
                usePersonName: "",
                usePerson: "",
              });
            });
          }
        );
      }
    },
    enteringTypeChange(type) {
      console.log(type);
      if (this.formParams.enteringType === type) {
        return;
      }
      if (type) {
        this.$set(this.formParams, "items", [{ assetCode: this.currentCode }]);
      } else {
        this.$set(this.formParams, "items", [{ assetCode: this.currentCode }]);
        this.$set(this.formParams, "startCode", this.currentCode);
        this.$set(this.formParams, "countNum", "");
      }

      this.$set(this.formParams, "enteringType", type);
      //
      console.log(this.formParams);
    },
    assetAdminCallBack(data) {
      if (data.id) {
        this.$set(this.formParams, "assetAdminName", data.staffName);
        this.$set(this.formParams, "assetAdmin", data.id);
      }
    },
    assetAdminFocus() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          queryType: "admin",
          callBack: this.assetAdminCallBack,
        },
      });
    },
    accountCallBack(data) {
      if (data.id) {
        this.$set(
          this.formParams.items[this.userIndex],
          "usePersonName",
          data.staffName
        );
        this.$set(this.formParams.items[this.userIndex], "usePerson", data.id);
      }
    },
    usePersonFocus(index, deptId) {
      this.userIndex = index;
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          deptId,
          callBack: this.accountCallBack,
        },
      });
    },
    /* 重置form */
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    setEpcmodel(index) {
      this.$createDialog(this, {
        dialogConfig: {
          title: "绑定EPC",
          width: "360px",
        },
        namespace: "asset_epc_search",
        whetherDestruction: true,

        assemblyConfig: {
          parentform: this.formParams,
          currentIndex: index,
        },
      });
    },
    submit() {
      // window.scrollTo(0,0);

      this.$formValidate(this, "ruleForm")
        .then(() => {
          let submit = JSON.parse(JSON.stringify(this.formParams));
          this.$requestAxiosForm(
            {
              url: "/pc/asset/add",
              data: submit,
            },
            (data) => {
              this.$success();
              this.formParams = JSON.parse(JSON.stringify(this.newForm));
              setTimeout(() => {
                this.init();
              });
              this.$refs.parentbox.scrollIntoView(true);

              this.$nextTick(() => {
                this.$refs.ruleForm.clearValidate();
              });
            }
          );
        })
        .catch(() => {});
    },
    /*  文件上传 start*/
    beforeUpload(file) {
      let type = file.name.substring(file.name.lastIndexOf(".")); //截取获得后缀名
      let size = file.size / 1024 / 1024 < 500;

      if (!size) {
        this.$message.error(`导入的文件大小超过10MB`);
        return false;
      }
      if ([".png", ".jpg", ".jpeg"].indexOf(type) >= 0) {
        return true;
      } else {
        this.$message.error("不支持此类文件格式!");
        return false;
      }
    },
    errorfield(err, file, fileList) {
      this.$message.error("文件上传失败!");
    },
    successfield(response, file, fileList) {
      if (response.status == "200") {
        this.$set(this.formParams, "cover", file.response.data);
      } else {
        this.$message.error(file.response.msg);
        this.$set(this.formParams, "cover", "");
      }
    },
    /*  文件上传 end*/

    /* 清空所有items的使用人 */
    clearitemusePerson() {
      for (let i = 0; i < this.formParams.items.length; i++) {
        this.$set(this.formParams.items[i], "usePerson", "");
        this.$set(this.formParams.items[i], "usePersonName", "");
      }
    },

    add_items(index) {
      if (index == -1) {
        this.$prompt("逐个录入-新增条数", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[0-9]*[1-9][0-9]*$/,
          inputErrorMessage: "只能输入正整数",
          inputValue: 1,
        })
          .then(({ value }) => {
            let _this = this;
            let count = parseInt(value);

            if (count && count == 1) {
              this.formParams.items.push({
                assetName:
                  this.formParams.items[this.formParams.items.length - 1]
                    .assetName || "",
              });
              this.getCode(
                this.formParams.items.length - 1,
                this.formParams.items[this.formParams.items.length - 2]
                  .assetCode
              );
            } else if (count && count > 1) {
              this.getCodesList(
                {
                  code: this.formParams.items[this.formParams.items.length - 1]
                    .assetCode,
                  count: count,
                },
                (codeList) => {
                  console.log(codeList);
                  let assetName =
                    _this.formParams.items[_this.formParams.items.length - 1]
                      .assetName || "";
                  console.log(_this.formParams);
                  for (let i = 1; i < codeList.length; i++) {
                    _this.formParams.items.push({
                      assetName,

                      assetCode: codeList[i],
                    });
                  }
                  console.log(_this.formParams);
                  /* 请求回调 */
                  console.log(codeList);
                }
              );
            }
          })
          .catch(() => {});
        // this.formParams.items.push({
        //   assetName:
        //     this.formParams.items[this.formParams.items.length - 1].assetName ||
        //     "",
        // });
        // this.getCode(
        //   this.formParams.items.length - 1,
        //   this.formParams.items[this.formParams.items.length - 2].assetCode
        // );
      } else {
        this.formParams.items.splice(index, 1);
      }
      console.log(this.formParams);
    },

    start_add(model) {
      switch (model) {
        case "assetClassify":
          this.$createDialog(this, {
            dialogConfig: {
              title: "分类新增",
              width: "360px",
            },
            namespace: "sys_add_classify",
            whetherDestruction: true,

            assemblyConfig: {
              parentId: "0",
              callBack: this.getClassifyArr,
            },
          });
          break;
        case "deptId":
          this.$createDialog(this, {
            dialogConfig: { title: "组织新增", width: "360px" },
            namespace: "sys_add_dept",
            whetherDestruction: true,

            assemblyConfig: {
              callBack: this.getDeptArr,
            },
          });
          break;
        case "useDeptId":
          this.$createDialog(this, {
            dialogConfig: { title: "组织新增", width: "360px" },
            namespace: "sys_add_dept",
            whetherDestruction: true,

            assemblyConfig: {
              callBack: this.getDeptArr,
            },
          });
          break;

        case "assetAdminName":
          this.$createDialog(this, {
            dialogConfig: { title: "新增人员", width: "720px" },
            namespace: "sys_add_account",
            whetherDestruction: true,

            assemblyConfig: {
              row: {},
            },
          });
          break;
        case "areaId":
          this.$createDialog(this, {
            dialogConfig: {
              title: "区域新增",
              width: "360px",
            },
            namespace: "sys_add_area",
            whetherDestruction: true,

            assemblyConfig: {
              row: {},
              callBack: this.$refs.area[0].resetNode,
            },
          });
          break;
      }
      return;
    },
    usePersonChange(data, index) {
      if (data) {
        let node = this.$refs.usePerson[0].nodeData;
        for (let i = 0; i < node.length; i++) {
          if (node[i].id == data) {
            this.$set(
              this.formParams.items[index],
              "usePersonName",
              node[i].staffName
            );
            break;
          }
        }
      } else {
        this.$set(this.formParams.items[index], "usePersonName", "");
      }
    },
    sourceChange(data) {
      if (data) {
        let node = this.$refs.source[0].nodeData;
        for (let i = 0; i < node.length; i++) {
          if (node[i].id == data) {
            this.$set(this.formParams, "sourceName", node[i].defValue);
            break;
          }
        }
      } else {
        this.$set(this.formParams, "sourceName", "");
      }
    },
    tempChange(data) {
      if (data) {
        this.getTemplateForm(data);
        let node = this.$refs.temp.nodeData;
        for (let i = 0; i < node.length; i++) {
          if (node[i].id == data) {
            this.$set(this.formParams, "tempName", node[i].tName);
            break;
          }
        }
      } else {
        this.$set(this.formParams, "tempName", "");
        this.$set(this.formParams, "tempCustom", []);
      }
    },
    areaChange(data) {
      if (data) {
        let node = this.$refs.area[0].nodeData;
        for (let i = 0; i < node.length; i++) {
          if (node[i].id == data) {
            this.$set(this.formParams, "areaName", node[i].aName);
            break;
          }
        }
      } else {
        this.$set(this.formParams, "areaName", "");
      }
    },

    assetAdminChange(data) {
      if (data) {
        let node = this.$refs.assetAdmin[0].nodeData;
        for (let i = 0; i < node.length; i++) {
          if (node[i].id == data) {
            this.$set(this.formParams, "assetAdminName", node[i].staffName);
            break;
          }
        }
      } else {
        this.$set(this.formParams, "assetAdminName", "");
      }
    },
    closedeptselect(node) {
      if (!node) {
        this.$set(this.formParams, "deptName", "");
      }
    },
    closeassetClassify(node) {
      if (!node) {
        this.$set(this.formParams, "assetClassifyName", "");
      }
    },
    closeuseDeptselect(node) {
      if (!node) {
        this.$set(this.formParams, "useDeptName", "");
      }
    },
    assetClassifyselect(node) {
      this.$set(this.formParams, "assetClassifyName", node.cName);
    },
    useDeptselect(node) {
      this.$set(this.formParams, "useDeptName", node.deptName);
      this.userparams.deptId = node.id;
    },
    deptselect(node) {
      this.$set(this.formParams, "deptName", node.deptName);
    },
    /* 递归处理空的children */
    treelabelFulter(arr, label) {
      arr.forEach((item) => {
        item.label = item[label];
        if (item.children == [] || item.children == "") {
          delete item.children;
        }
        if (item.children && item.children.length) {
          this.treelabelFulter(item.children, label);
        }
      });
    },
    /* 资产分类page */
    getClassifyArr() {
      this.treeKey++
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: "0" },
        },
        (data) => {
          let newData = data.data || [];
          let result = newData.map((item) => {
            item.label = item.cName;
            item.children = null;
            return item;
          });
          this.classifyArr = result;
        }
      );
    },

    /* 获取模板表单列表 */
    getTemplateForm(id) {
      this.$requestAxios(
        {
          url: "/pc/template/form/page",
          data: { id },
        },
        (data) => {
          this.$set(this.formParams, "tempCustom", data.data);
        }
      );
    },

    /* 所属组织  使用组织 */
    getDeptArr() {
      this.$requestAxios(
        {
          url: "/pc/dept/tree",
          data: {},
        },
        (data) => {
          this.treelabelFulter(data.data, "deptName");
          this.deptArr = data.data;
        }
      );
    },

    /* 资产编码 */
    getCode(index, code) {
      this.$requestAxios(
        {
          url: "/pc/asset/get_code",
          data: {
            code,
          },
        },
        (data) => {
          this.$set(this.formParams.items[index], "assetCode", data.data);
          this.currentCode = data.data;
        }
      );
    },
    init() {
      this.getCode(0);
      this.getClassifyArr();
      this.getDeptArr();
    },
  },
};
</script>
<style scoped>
.assetbox {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
}

.entering-box {
  display: flex;
}

.entering-box .enteringActive {
  border-color: #436bff;
}

.entering-box .enteringActive > span:first-child {
  border: 2px solid #436bff;
  box-sizing: border-box;
}

.entering-box .enteringActive > span:last-child {
  color: #436bff;
}

.entering-box > div {
  cursor: pointer;
  width: 100px;
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

.entering-box > div:first-child {
  margin-right: 20px;
}

.entering-box > div > span:first-child {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  box-sizing: border-box;

  border: 1px solid #e0e0e0;
}

.entering-box > div > span:last-child {
  color: #1e1e1e;
  font-size: 14px;
  margin-left: 6px;
}

.box_bottom {
  position: absolute;
  border-top: 1px solid #e0e0e0;
  bottom: 0;
  right: 0;
  z-index: 1;
  width: 100%;
}

.box_bottom > div:first-child {
  height: 80px;
}

.dividerTitle {
  font-size: 18px;
  letter-spacing: 0px;
  color: #436bff;
  font-weight: bold;
}

.addBtn {
  width: 36px;
  height: 36px;
  margin-left: 20px;
  background-color: #436bff;
  border-radius: 4px;
  color: #fff;
}
</style>
